import React from 'react';
import PropTypes from 'prop-types';

const PaginateItem = ({
  children, onClick, page, active
}) => {
  return (
    <div
      role="presentation"
      onClick={onClick}
      className={`
        flex mr-[5px] border border-whiteHover dark:border-[#1b263b] rounded-[5px]
        text-[14px] w-[32px] h-[32px] justify-center items-center
        ${active ? 'text-white bg-primary' : ''}
        hover:text-primary hover:bg-whiteHover dark:hover:bg-[#415a77] cursor-pointer
      `}
      key={page}
    >
      {children}
    </div>
  );
};

PaginateItem.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  page: PropTypes.number,
  active: PropTypes.bool
};

PaginateItem.defaultProps = {
  onClick: () => {},
  page: 1,
  active: false
};

export default PaginateItem;
